import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-asc-w",
  "use": "icon-asc-w-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-asc-w\"><path d=\"M426.666667 554.666667v-85.333334h341.333333v85.333334h-341.333333m0 256v-85.333334h170.666666v85.333334h-170.666666m0-512V213.333333h512v85.333334H426.666667M256 725.333333h106.666667L213.333333 874.666667 64 725.333333H170.666667V170.666667h85.333333v554.666666z\" fill=\"#ffffff\" p-id=\"11880\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol